import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "d-flex align-items-center position-relative my-1" }
const _hoisted_5 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_6 = { class: "card-body pt-0" }
const _hoisted_7 = { class: "btn-group dropstart" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-sm btn-light dropdown-toggle",
  type: "button",
  id: "actions",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, " Actions ", -1)
const _hoisted_9 = {
  class: "dropdown-menu",
  "aria-labelledby": "actions"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_EditTransactionModal = _resolveComponent("EditTransactionModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen021.svg" })
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
              onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchItems())),
              class: "form-control form-control-solid w-250px ps-15",
              placeholder: "Search Transactions"
            }, null, 544), [
              [_vModelText, _ctx.search]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (!_ctx.loading)
          ? (_openBlock(), _createBlock(_component_Datatable, {
              key: 0,
              "table-data": _ctx.tableData,
              "table-header": _ctx.tableHeader,
              "enable-items-per-page-dropdown": true
            }, {
              "cell-product-title": _withCtx(({ row: transaction }) => [
                _createTextVNode(_toDisplayString(transaction.Product.title), 1)
              ]),
              "cell-stock-title": _withCtx(({ row: transaction }) => [
                _createTextVNode(_toDisplayString(transaction.Stock.title), 1)
              ]),
              "cell-quantity": _withCtx(({ row: transaction }) => [
                _createTextVNode(_toDisplayString(transaction.quantity), 1)
              ]),
              "cell-UpdatedAt": _withCtx(({ row: transaction }) => [
                _createTextVNode(_toDisplayString(_ctx.formatDate(transaction.UpdatedAt)), 1)
              ]),
              "cell-actions": _withCtx(({ row: transaction }) => [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("ul", _hoisted_9, [
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        href: "javascript:;",
                        "data-bs-toggle": "modal",
                        "data-bs-target": "#kt_modal_edit_transaction",
                        onClick: ($event: any) => (_ctx.selectTransaction(transaction))
                      }, "Edit", 8, _hoisted_10)
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        href: "javascript:;",
                        onClick: ($event: any) => (_ctx.deleteTransaction(transaction.ID))
                      }, "Delete", 8, _hoisted_11)
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["table-data", "table-header"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_EditTransactionModal, {
      transaction: _ctx.selectedTransaction,
      reloadData: _ctx.fetchData
    }, null, 8, ["transaction", "reloadData"])
  ], 64))
}